import { render, staticRenderFns } from "./InboxIcon.vue?vue&type=template&id=5bfa8c6a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bfa8c6a')) {
      api.createRecord('5bfa8c6a', component.options)
    } else {
      api.reload('5bfa8c6a', component.options)
    }
    module.hot.accept("./InboxIcon.vue?vue&type=template&id=5bfa8c6a", function () {
      api.rerender('5bfa8c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/InboxIcon.vue"
export default component.exports